<mat-card style="height:100%;overflow-y: auto;">
  <div class="py-2 d-flex" style="flex-direction: row-reverse; margin-right: 1%;">
    <button mat-raised-button class="custom-button1" title="Export Details" (click)="openExportFormatDialog()">
      <mat-icon style="margin-right: 5px;">download</mat-icon>
    </button>
  </div>
    <mat-card-header>

      <mat-card-title>
        <!-- <h1>Bills or Receipts</h1> -->
      </mat-card-title>
    </mat-card-header>
    <mat-tab-group (selectedTabChange)="switchTab($event)">
    
      <mat-tab label="Details" style="font-weight: bold;">
        <ng-template mat-tab-label style="color: white!important;font-weight: bolder!important; ">
          <span class="laberClass">Details</span> 
        </ng-template>
        <div class="card-container row m-0">
          <mat-card class="card-bill col-md-3 mb-3 p-2" *ngFor="let element of dataSource.data"  style="cursor: pointer;" (click)="showDetails(element)">
            <mat-card-content class="card-content">
              <div class="content-left">
                <h5 matTooltip="Edit Bill"
                matTooltipClass="custom-tooltip">{{ element.name }}</h5>
                <p class="m-0">Created By: {{ element.user_id.name }}</p>
                <p class="m-0">CATEGORY: {{ element.category_id.name }}</p>
                <p class="m-0">Amount: {{ element.amount_info.value }}</p>
                <p class="m-0">Status: {{ getLatestStatus(element) }}</p>
              </div>
              <div class="image-container content-right">
                <mat-spinner *ngIf="!imageLoaded[element._id]" class="page-spinner" diameter="40"></mat-spinner>
                <img [src]="getImageUrlObservable(element.bill_image.file) | secure | async" alt="Image"
                  class="image-zoom" (load)="imageLoadedFor(element._id)">
              </div>
              <div class="icon-container">
                <mat-icon *ngIf="element.user_id._id===getUserIdFromLocal()" style="color: rgb(0, 0, 0); cursor: pointer;" matTooltip="Remove bill from this trip"
                  matTooltipClass="custom-tooltip"
                  (click)="removeBillFromTrip($event,element._id,element._etag)">delete</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>
      <mat-tab label="Chart" >
        <ng-template mat-tab-label style="color: white!important;font-weight: bolder!important; ">
          <span class="laberClass">Visualization</span> 
        </ng-template>
      <div *ngIf="dataSource.data.length>0" class="card-containerChart">
        <canvas  id="pieChart" width="400" height="400"></canvas>
      </div>
      </mat-tab>
  </mat-tab-group>
  </mat-card>


<button mat-raised-button class="custom-button" (click)="openBillAdd()">
  <div>
    <mat-icon>receipt_long</mat-icon>
    Assign New Bill
  </div>
</button>

